// extracted by mini-css-extract-plugin
export default {"tips":"styles_tips__9s47u","dropdown":"styles_dropdown__deiv-"};